export default __webpack_public_path__ + "static/media/defaultBgForProUser.b145ef65.jpg";